import { Image } from "src/swsh-native";
import { GatheringHeaderProps } from "../types";

const GatheringHeaderThumbnailImage = ({
	thumbnailUrl_1x1,
}: Pick<GatheringHeaderProps, "thumbnailUrl_1x1">) => {
	if (!thumbnailUrl_1x1) return null;
	return (
		<Image
			pointerEvents="none"
			alt="Album Thumbnail"
			src={thumbnailUrl_1x1}
			dim="auto"
			style={{
				width: "100%",
				height: "100%",
			}}
		/>
	);
};
export default GatheringHeaderThumbnailImage;
